import React, { useState } from 'react';
import { Modal, Button, Upload, message } from 'antd';
import { UploadChangeParam } from 'antd/lib/upload';
import { UploadFile } from 'antd/lib/upload/interface';
import styled from 'styled-components';
import { ModalProps } from 'antd/lib/modal';
import { DownloadOutlined } from '@ant-design/icons';
import PatientsTemplateFile from 'assets/patients-template.csv';
import { FormattedMessage } from 'react-intl';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
interface BusinessPartnerImportPatientsModalProps extends ModalProps {
  hideModal: () => void;
  importRequest: (file: File | Blob) => void;
  loading: boolean;
}

export interface ImportFileDTO {
  file: File | Blob;
}

const UploadFileWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.2rem 0.4rem;
  border: 1px solid #dad7d7;
`;

const TemplateButtonWrapper = styled.div`
  width: 100%;
  display: flex;
`;

const TemplateButton = styled(Button)`
  margin-left: auto;
  margin-bottom: 2rem;
`;

export const BusinessPartnerImportPatientsModal: React.FC<BusinessPartnerImportPatientsModalProps> = ({
  hideModal,
  importRequest,
  loading,
  ...modalProps
}) => {
  const [uploadedFile, setUploadedFile] = useState<UploadFile>();
  const intlMessage = useFormatMessage();

  const handleChange = (data: UploadChangeParam<UploadFile<any>>) => {
    if (data.file) {
      const fileExtension = data.file.name.split('.').pop();

      if (!data.file.originFileObj) {
        return message.error(`Invalid file`);
      }

      if (fileExtension !== 'csv') {
        return message.error(
          intlMessage(
            { id: 'validation.wrongFileExtension' },
            { fileExtension, allowedExtension: 'csv' }
          )
        );
      }

      setUploadedFile(data.file);
    }
  };

  return (
    <>
      <Modal
        title={intlMessage({ id: 'patients.import' })}
        onCancel={() => {
          setUploadedFile(undefined);
          hideModal();
        }}
        footer={[
          <Button
            key="cancel"
            loading={false}
            onClick={() => {
              setUploadedFile(undefined);
              hideModal();
            }}
          >
            <FormattedMessage id="cancel" />
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => {
              importRequest(uploadedFile!.originFileObj!);
              setUploadedFile(undefined);
            }}
            disabled={!uploadedFile?.originFileObj}
          >
            <FormattedMessage id="import" />
          </Button>,
        ]}
        {...modalProps}
      >
        <TemplateButtonWrapper>
          <TemplateButton
            icon={<DownloadOutlined />}
            href={PatientsTemplateFile}
            download={'patients-template.csv'}
          >
            {intlMessage({ id: 'fileTemplate' })}
          </TemplateButton>
        </TemplateButtonWrapper>
        <UploadFileWrapper>
          {uploadedFile?.name || intlMessage({ id: 'import' }) + ' CSV'}
          <Upload
            showUploadList={false}
            onChange={handleChange}
            customRequest={() => {
              /*Disable default request*/
            }}
          >
            <Button>
              <FormattedMessage id="browse" />
            </Button>
          </Upload>
        </UploadFileWrapper>
      </Modal>
    </>
  );
};
